import React from "react";
import { Card, CardHeader, CardContent } from "ui/components/card";
import { ShimmerEffect } from "@/components/shimmer";

export default function ChartCardSkeleton() {
    return (
        <Card className="mx-6 mt-4 mb-6 p-0 gap-0 border-1 radius-xl animate-pulse">
            {/* Header */}
            <CardHeader className="flex flex-row items-center justify-between !p-4 border-b bg-white">
                <div className="flex items-center gap-2">
                    <ShimmerEffect className="h-4 w-4rounded" />
                    <div className="h-4 w-24  rounded" />
                </div>

                <div className="flex flex-wrap items-center gap-4 text-xs">
                    {Array.from({ length: 5 }).map((_, i) => (
                        <div key={i} className="flex items-center gap-1.5">
                            <ShimmerEffect className="h-3 w-3 rounded-xs " />
                            <ShimmerEffect className="h-3 w-12 rounded" />
                        </div>
                    ))}
                </div>
            </CardHeader>

            {/* Content Skeleton */}
            <CardContent className="pt-6">
                <div className="relative h-[400px]">
                    {/* Y-axis labels and grid lines */}
                    <div className="absolute h-[80%] m-auto flex flex-col justify-between pr-4">
                        {Array.from({ length: 5 }).map((_, i) => (
                            <div key={i} className="flex items-center gap-3">
                                <ShimmerEffect className="h-3 w-8 rounded" />
                                <div className="flex-1 h-px bg-gray-100" />
                            </div>
                        ))}
                    </div>

                    {/* Bar chart */}
                    <div className="absolute inset-0 flex items-end justify-around px-12 pb-16">
                        {[60, 80, 45, 90, 65, 50].map((height, i) => (
                            <ShimmerEffect
                                key={i}
                                className="w-12 h-20 rounded"
                                style={{ height: `${height}%` }}
                            />
                        ))}
                    </div>

                    {/* X-axis labels */}
                    <div className="absolute bottom-4 w-full flex justify-around px-12">
                        {Array.from({ length: 5 }).map((_, i) => (
                            <ShimmerEffect key={i} className="h-3 w-16 rounded" />
                        ))}
                    </div>
                </div>
            </CardContent>
        </Card>
    );
}
